var _path, _circle, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.803 25.0392H18.9867C18.3516 25.0392 17.9274 24.8453 17.7566 24.6746C17.7174 24.6355 17.6983 24.6045 17.6896 24.5855C17.6818 24.5682 17.6821 24.5605 17.6821 24.5593L17.6821 24.5593C17.6822 24.5587 17.6821 24.5488 17.6945 24.5269C17.7077 24.5034 17.7367 24.464 17.7966 24.4141L19.7007 22.827C20.4899 22.1692 20.9731 21.3463 20.9731 20.446V14.8331C20.9731 13.0807 22.2906 11.3824 24.669 10.093C27.0278 8.81423 30.3208 8.00791 33.9854 8.00791H35.8044C39.469 8.00791 42.7619 8.81423 45.1207 10.093C47.4991 11.3824 48.8167 13.0807 48.8167 14.8331V20.446C48.8167 21.3463 49.2999 22.1692 50.0891 22.827L51.9932 24.4141C52.0531 24.464 52.082 24.5034 52.0953 24.5269C52.1076 24.5488 52.1076 24.5587 52.1076 24.5593V24.5593C52.1077 24.5605 52.108 24.5682 52.1001 24.5855C52.0914 24.6045 52.0723 24.6355 52.0332 24.6746C51.8624 24.8453 51.4382 25.0392 50.803 25.0392Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "url(#paint0_radial_21598_21586)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 17.5,
    fill: "url(#paint1_linear_21598_21586)",
    stroke: "url(#paint2_radial_21598_21586)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5V22.4C20 22.463 20.0296 22.5222 20.08 22.56L24 25.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21598_21586)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.1852,
    cy: 25.1852,
    r: 9.18519,
    fill: "url(#paint3_linear_21598_21586)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1852,
    cy: 25.1852,
    r: 9.18519,
    fill: "url(#paint4_radial_21598_21586)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1852,
    cy: 25.1852,
    r: 8.68519,
    stroke: "url(#paint5_radial_21598_21586)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1852,
    cy: 25.1852,
    r: 8.68519,
    stroke: "url(#paint6_radial_21598_21586)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_21598_21586)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_21598_21586",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3333 57.3333C57.4379 57.3333 58.3434 56.4357 58.2367 55.3363C57.7759 50.5882 55.6824 46.1219 52.2802 42.7197C48.4045 38.844 43.1478 36.6666 37.6667 36.6666C32.1855 36.6666 26.9289 38.844 23.0531 42.7197C19.6509 46.1219 17.5574 50.5882 17.0966 55.3363C16.99 56.4357 17.8954 57.3333 19 57.3333L37.6667 57.3333H56.3333Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.3333 57.3333C57.4379 57.3333 58.3434 56.4357 58.2367 55.3363C57.7759 50.5882 55.6824 46.1219 52.2802 42.7197C48.4045 38.844 43.1478 36.6666 37.6667 36.6666C32.1855 36.6666 26.9289 38.844 23.0531 42.7197C19.6509 46.1219 17.5574 50.5882 17.0966 55.3363C16.99 56.4357 17.8954 57.3333 19 57.3333L37.6667 57.3333H56.3333Z",
    fill: "url(#paint7_linear_21598_21586)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3333 57.3333C57.4379 57.3333 58.3434 56.4357 58.2367 55.3363C57.7759 50.5882 55.6824 46.1219 52.2802 42.7197C48.4045 38.844 43.1478 36.6666 37.6667 36.6666C32.1855 36.6666 26.9289 38.844 23.0531 42.7197C19.6509 46.1219 17.5574 50.5882 17.0966 55.3363C16.99 56.4357 17.8954 57.3333 19 57.3333L37.6667 57.3333H56.3333Z",
    fill: "url(#paint8_radial_21598_21586)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3333 57.3333C57.4379 57.3333 58.3434 56.4357 58.2367 55.3363C57.7759 50.5882 55.6824 46.1219 52.2802 42.7197C48.4045 38.844 43.1478 36.6666 37.6667 36.6666C32.1855 36.6666 26.9289 38.844 23.0531 42.7197C19.6509 46.1219 17.5574 50.5882 17.0966 55.3363C16.99 56.4357 17.8954 57.3333 19 57.3333L37.6667 57.3333H56.3333Z",
    stroke: "url(#paint9_radial_21598_21586)",
    strokeWidth: 2,
    mask: "url(#path-6-inside-1_21598_21586)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3333 57.3333C57.4379 57.3333 58.3434 56.4357 58.2367 55.3363C57.7759 50.5882 55.6824 46.1219 52.2802 42.7197C48.4045 38.844 43.1478 36.6666 37.6667 36.6666C32.1855 36.6666 26.9289 38.844 23.0531 42.7197C19.6509 46.1219 17.5574 50.5882 17.0966 55.3363C16.99 56.4357 17.8954 57.3333 19 57.3333L37.6667 57.3333H56.3333Z",
    stroke: "url(#paint10_radial_21598_21586)",
    strokeWidth: 2,
    mask: "url(#path-6-inside-1_21598_21586)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21598_21586",
    x: 22,
    y: 10,
    width: 30.3706,
    height: 30.3704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21586",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_21598_21586",
    x: 11.0879,
    y: 30.6666,
    width: 53.1572,
    height: 32.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21586",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21598_21586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.6445 -1.9737) rotate(39.0492) scale(30.703 32.1973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21598_21586",
    x1: 2,
    y1: 3,
    x2: 20,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_21598_21586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7.69231 -14.3077) rotate(55.5392) scale(42.8225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21598_21586",
    x1: 28.5741,
    y1: 15.3665,
    x2: 42.7021,
    y2: 35.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_21598_21586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5741 15.3665) scale(17.2222 24.0715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_21598_21586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5556 24.5517) rotate(37.113) scale(12.5981 12.9968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_21598_21586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.9259 14.0996) rotate(122.39) scale(7.50172 7.22293)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_21598_21586",
    x1: 18.2917,
    y1: 35.2413,
    x2: 44.9686,
    y2: 63.2201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_21598_21586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2917 35.2413) scale(38.75 54.1609)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_21598_21586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.25 55.908) rotate(37.113) scale(28.3457 29.2429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_21598_21586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5833 32.3907) rotate(122.39) scale(16.8789 16.2516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.9a635cb3b5a0e82db96d03568a24d322.svg";
export { ForwardRef as ReactComponent };